import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass, toDisplayString as _toDisplayString } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "grid-col",
  style: {"width":"185px"}
}
const _hoisted_2 = ["onClick"]
const _hoisted_3 = ["innerHTML"]
const _hoisted_4 = {
  class: "grid-col",
  style: {"width":"450px"}
}
const _hoisted_5 = { class: "grid-col-divisions" }
const _hoisted_6 = ["onClick"]
const _hoisted_7 = ["innerHTML"]
const _hoisted_8 = { class: "grid-col-divisions-division-row-length" }
const _hoisted_9 = ["onClick"]
const _hoisted_10 = ["innerHTML"]
const _hoisted_11 = {
  key: 1,
  class: "grid-col",
  style: {"width":"205px"}
}
const _hoisted_12 = { class: "grid-col-group" }
const _hoisted_13 = ["onClick"]
const _hoisted_14 = ["innerHTML"]
const _hoisted_15 = {
  key: 1,
  class: "grid-empty"
}

import { ref } from "vue";
// import AppCheckbox from "../../ui-kit/checkbox/AppCheckbox.vue";
import AppCheckbox from "@/components/ui-kit/checkbox/AppCheckbox.vue";
import type {
  SelectGroup,
  SelectOption,
} from "@/components/ui-kit/select/AppSelect.vue";


export default /*@__PURE__*/_defineComponent({
  __name: 'UserGroupDropdownContent',
  props: {
    items: {},
    selected: {},
    select: { type: Function },
    getGroupState: { type: Function },
    updateSelected: { type: Function },
    search: {},
    singleMode: { type: Boolean },
    close: { type: Function },
    currentOwner: {}
  },
  setup(__props: any) {

const props = __props;

const searchMode = ref(false);
const searchText = ref("");

const handleSelect = (id: string | number) => {
  if (props.updateSelected) {
    const isAlreadySelected = props.selected.includes(id);
    const newSelected = isAlreadySelected
      ? props.selected.filter((s) => s !== id)
      : [...props.selected, id];
    props.updateSelected(newSelected);
  } else if (typeof props.select === "function") {
    props.select(id);
  }

  if (props.singleMode && props.close) {
    props.close();
  }
};

const toggleGroup = (group: SelectGroup) => {
  if (!group.children?.length) return;
  const childIds = group.children.map((child) => child.id);
  const allSelected = childIds.every((id) => props.selected.includes(id));

  if (props.updateSelected) {
    const newSelected = allSelected
      ? props.selected.filter((id) => !childIds.includes(id))
      : [
          ...props.selected,
          ...childIds.filter((id) => !props.selected.includes(id)),
        ];
    props.updateSelected(newSelected);
  } else {
    childIds.forEach((id) => {
      if (typeof props.select !== "function") return;
      if (allSelected && props.selected.includes(id)) props.select(id);
      else if (!allSelected && !props.selected.includes(id)) props.select(id);
    });
  }
};

const escapeHtml = (text: string): string => {
  const div = document.createElement("div");
  div.textContent = text;
  return div.innerHTML;
};

const highlightedName = (label: string): string => {
  const searchTerm = props.search?.trim();
  if (!searchTerm) {
    return escapeHtml(label);
  }

  const lowerLabel = label.toLowerCase();
  const lowerSearch = searchTerm.toLowerCase();
  const startIndex = lowerLabel.indexOf(lowerSearch);

  if (startIndex === -1) {
    return escapeHtml(label);
  }

  const endIndex = startIndex + searchTerm.length;
  const beforeMatch = label.substring(0, startIndex);
  const match = label.substring(startIndex, endIndex);
  const afterMatch = label.substring(endIndex);

  return `${escapeHtml(
    beforeMatch,
  )}<span style="background-color:#D3E3FD;border-radius:4px;padding:1px;">${escapeHtml(
    match,
  )}</span>${escapeHtml(afterMatch)}`;
};

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(["grid", { 'grid--empty': _ctx.items.length === 0 }])
  }, [
    (_ctx.items.length !== 0)
      ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
          (_ctx.singleMode)
            ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
                _cache[0] || (_cache[0] = _createElementVNode("div", { class: "grid-col-title" }, "Группы", -1)),
                _createElementVNode("div", {
                  class: _normalizeClass(["grid-col-group", { 'grid-col-group-single': _ctx.singleMode }])
                }, [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.items.filter(
              (i) =>
                i.type === 'group' && (!i.children || i.children.length === 0),
            ), (item) => {
                    return (_openBlock(), _createElementBlock("div", {
                      class: _normalizeClass(["grid-col-group-row", { 'grid-col-group-row-single': _ctx.singleMode }]),
                      key: item.id,
                      onClick: ($event: any) => (handleSelect(item.id))
                    }, [
                      (!_ctx.singleMode)
                        ? (_openBlock(), _createBlock(AppCheckbox, {
                            key: 0,
                            value: _ctx.selected.includes(item.id),
                            onOnChange: ($event: any) => (handleSelect(item.id))
                          }, null, 8, ["value", "onOnChange"]))
                        : _createCommentVNode("", true),
                      _createElementVNode("span", {
                        class: _normalizeClass(["grid-col-group-row-label", {
                'grid-col-group-row-label--selected':
                  _ctx.singleMode && _ctx.currentOwner === item.id,
              }]),
                        innerHTML: highlightedName(item.label)
                      }, null, 10, _hoisted_3)
                    ], 10, _hoisted_2))
                  }), 128))
                ], 2)
              ]))
            : _createCommentVNode("", true),
          _createElementVNode("div", _hoisted_4, [
            _cache[1] || (_cache[1] = _createElementVNode("div", { class: "grid-col-title" }, "Пользователи", -1)),
            _createElementVNode("div", _hoisted_5, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.items.filter(
              (i) => i.type === 'group' && i.children?.length,
            ), (item) => {
                return (_openBlock(), _createElementBlock("div", {
                  key: item.id,
                  class: "grid-col-divisions-division"
                }, [
                  _createElementVNode("div", {
                    class: "grid-col-divisions-division-row",
                    onClick: ($event: any) => (toggleGroup(item))
                  }, [
                    (item.id !== -1 && !_ctx.singleMode)
                      ? (_openBlock(), _createBlock(AppCheckbox, {
                          key: 0,
                          class: "grid-col-divisions-division-row-checkbox",
                          value: _ctx.getGroupState(item).isSelected,
                          onOnChange: ($event: any) => (toggleGroup(item))
                        }, null, 8, ["value", "onOnChange"]))
                      : _createCommentVNode("", true),
                    _createElementVNode("div", {
                      class: "grid-col-divisions-division-row-label",
                      innerHTML: highlightedName(item.label)
                    }, null, 8, _hoisted_7),
                    _createElementVNode("div", _hoisted_8, _toDisplayString(item.children.length), 1)
                  ], 8, _hoisted_6),
                  _createElementVNode("div", {
                    class: _normalizeClass(["grid-col-divisions-division-user", {
                'grid-col-divisions-division-user-single': _ctx.singleMode,
              }])
                  }, [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(item.children, (child) => {
                      return (_openBlock(), _createElementBlock("div", {
                        key: child.id,
                        class: _normalizeClass(["grid-col-divisions-division-user-row", {
                  'grid-col-divisions-division-user-row-single': _ctx.singleMode,
                  'grid-col-divisions-division-user-row--selected':
                    _ctx.singleMode && _ctx.currentOwner === child.id,
                }]),
                        onClick: ($event: any) => (handleSelect(child.id))
                      }, [
                        (!_ctx.singleMode)
                          ? (_openBlock(), _createBlock(AppCheckbox, {
                              key: 0,
                              class: "grid-col-divisions-division-user-row-checkbox",
                              value: _ctx.selected.includes(child.id),
                              onOnChange: ($event: any) => (handleSelect(child.id))
                            }, null, 8, ["value", "onOnChange"]))
                          : _createCommentVNode("", true),
                        _createElementVNode("div", {
                          class: _normalizeClass(["grid-col-divisions-division-user-row-label", {
                    'grid-col-divisions-division-user-row-label--selected':
                      _ctx.singleMode && _ctx.currentOwner === child.id,
                  }]),
                          innerHTML: highlightedName(child.label)
                        }, null, 10, _hoisted_10)
                      ], 10, _hoisted_9))
                    }), 128))
                  ], 2)
                ]))
              }), 128))
            ])
          ]),
          (!_ctx.singleMode)
            ? (_openBlock(), _createElementBlock("div", _hoisted_11, [
                _cache[2] || (_cache[2] = _createElementVNode("div", { class: "grid-col-title" }, "Группы", -1)),
                _createElementVNode("div", _hoisted_12, [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.items.filter(
              (i) =>
                i.type === 'group' && (!i.children || i.children.length === 0),
            ), (item) => {
                    return (_openBlock(), _createElementBlock("div", {
                      class: "grid-col-group-row",
                      style: {"gap":"8px"},
                      key: item.id,
                      onClick: ($event: any) => (handleSelect(item.id))
                    }, [
                      (!_ctx.singleMode)
                        ? (_openBlock(), _createBlock(AppCheckbox, {
                            key: 0,
                            class: "grid-col-group-row-checkbox",
                            value: _ctx.selected.includes(item.id),
                            onOnChange: ($event: any) => (handleSelect(item.id))
                          }, null, 8, ["value", "onOnChange"]))
                        : _createCommentVNode("", true),
                      _createElementVNode("span", {
                        class: "grid-col-group-row-label",
                        innerHTML: highlightedName(item.label)
                      }, null, 8, _hoisted_14)
                    ], 8, _hoisted_13))
                  }), 128))
                ])
              ]))
            : _createCommentVNode("", true)
        ], 64))
      : (_openBlock(), _createElementBlock("div", _hoisted_15, "Пользователи не найдены"))
  ], 2))
}
}

})